module.exports = __webpack_public_path__ + "img/services-5.f2bc00d2.jpg";